var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 22.3933V27.1081C28 27.8081 27.4588 28.3889 26.7607 28.4383C26.1775 28.4795 25.7017 28.5 25.3333 28.5C13.5512 28.5 4 18.9488 4 7.16667C4 6.79828 4.0206 6.32249 4.0618 5.73933C4.11116 5.04117 4.69192 4.5 5.39181 4.5H10.1068C10.449 4.5 10.7357 4.75923 10.77 5.09973C10.8009 5.40543 10.8296 5.65085 10.8561 5.83603C11.1258 7.71963 11.6767 9.51248 12.4649 11.1707C12.5915 11.4369 12.5089 11.7555 12.2691 11.9267L9.3914 13.9824C11.1434 18.0748 14.4252 21.3567 18.5176 23.1087L20.5695 20.2359C20.7429 19.9932 21.0653 19.9097 21.3347 20.0376C22.9928 20.8252 24.7855 21.3755 26.6688 21.6445C26.8528 21.6709 27.0967 21.6993 27.4003 21.73C27.7408 21.7644 28 22.0511 28 22.3933Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6472d115eb9c8c68d1213ba4e286974d.svg";
export { ForwardRef as ReactComponent };